'use client';

import { type Product } from '@/domain/products/types';
import { Box } from '@andritzot/metris-web-ui/layout/content/Box';

import { RepositoryDocumentFrame } from '../RepositoryDocumentFrame';

interface BrochureTabProps {
  detailedProduct: Product;
}

const BrochureTab = ({ detailedProduct }: BrochureTabProps) => (
  <Box sx={{ width: '100%', height: '100%' }}>
    <RepositoryDocumentFrame product={detailedProduct} documentPath={detailedProduct.documentation} />
  </Box>
);

export default BrochureTab;
